import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, BoxRadius, Color, Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import {
  ButtonSkeleton,
  DoubleTextSkeleton,
  ImageSkeleton,
  InputSkeleton,
  TextSkeleton,
} from '../../../../AssetsLoading';
import { LateralBar } from '../../../components/LateralBar';

export const ListLoadingItemMobile: React.FC = () => {
  const infos = [
    { label: 'Melhor Compra', value: <TextSkeleton w="60%" /> },
    { label: 'Melhor Venda', value: <TextSkeleton /> },
    { label: 'Fechamento', value: <TextSkeleton w="60%" /> },
  ];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']}>
      <LateralBar
        backgroundColor={Color['product.rendavariavel']}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between" alignItems="center">
          <HStack alignItems="center" space={Spacing['inline.xxxs']} w="45%">
            <ImageSkeleton />
            <DoubleTextSkeleton w="60%" />
          </HStack>
          <Stack w="25%">
            <DoubleTextSkeleton w="100%" />
          </Stack>
        </HStack>
        <HStack justifyContent="space-between">
          {infos.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label}>
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <VStack space={Spacing['inset.quarck']}>
          <UI.Text color="neutral.black" variant="semibold">
            Tipo da ordem
          </UI.Text>
          <InputSkeleton />
        </VStack>
        <VStack space={Spacing['stack.quarck']} w="full">
          <UI.Text color="neutral.black" variant="semibold">
            Quantidade
          </UI.Text>
          <InputSkeleton />
        </VStack>
        <VStack space={Spacing['stack.quarck']} w="full">
          <UI.Text color="neutral.black" variant="semibold">
            Preço por ativo
          </UI.Text>
          <InputSkeleton />
        </VStack>
        <HStack space={Spacing['inline.xxxs']} justifyContent="space-between" w="full">
          <VStack space={Spacing['stack.quarck']} w="40%">
            <DoubleTextSkeleton w="90%" />
          </VStack>
          <HStack alignSelf="flex-end" w="30%" space="inline.nano">
            <Stack w="1/2">
              <ButtonSkeleton borderRadius={BoxBorder.thick} />
            </Stack>
            <Stack w="1/2">
              <ButtonSkeleton borderRadius={BoxBorder.thick} />
            </Stack>
          </HStack>
        </HStack>
      </VStack>
    </TableContent>
  );
};
